import { h, RefObject } from 'preact'
import { i18n } from 'i18n/i18n'

interface CalculatorSelectSearchProps {
  searchValue: string
  setSearchValue: (value: string) => void
  searchInputRef: RefObject<HTMLInputElement>
  hasResults: boolean
}

export const CalculatorSelectSearch = ({
  searchValue,
  setSearchValue,
  searchInputRef,
  hasResults,
}: CalculatorSelectSearchProps) => (
  <div
    className="preact-select__search"
    onClick={(e) => e.stopPropagation()}
  >
    <input
      ref={searchInputRef}
      value={searchValue}
      type="text"
      className="preact-select__search-input"
      placeholder={`${i18n('preactSelect.search')}`}
      onInput={(e) => setSearchValue(e.currentTarget.value)}
    />
    {!hasResults && <p className="preact-select__search-error-message">{`${i18n('preactSelect.searchNoResults')}`}</p>}
  </div>
)
